






import {
  defineComponent,
  onMounted,
  computed,
  ref,
  useRoute,
} from "@nuxtjs/composition-api";
import { usePartsBySku } from "~/modules/part-finder/composables/usePartsBySku";
import SkeletonLoader from "components/theme/SkeletonLoader.vue";
import { storeToRefs } from "pinia";
import { usePartFinderStore } from "~/modules/part-finder/stores/partFinder";
import type { FittingListEntry } from "~/modules/part-finder/types";

export default defineComponent({
  name: "PartsNote",
  props: {
    sku: {
      type: String,
      required: true,
    },
  },
  components: {
    SkeletonLoader,
  },

  setup(props) {
    const { load, loading, error } = usePartsBySku(props.sku);

    const store = usePartFinderStore();

    const { selectedFinder, selectedBrand, selectedModel } = storeToRefs(store);

    const query = ref<string>("");
    const fittingList = ref<FittingListEntry[]>([]);

    const route = useRoute();

    function validatePfUrlArguments(query: string | string[] | null) {
      if (!query || Array.isArray(query)) {
        return null;
      }
      const queryParts = query.split(",");

      if (queryParts.length !== 3) {
        return null;
      }

      return {
        finder: queryParts[0],
        brand: queryParts[1],
        model: queryParts[2],
      };
    }

    const { pfa } = route.value.query;

    const pfUrlArguments = validatePfUrlArguments(pfa);

    const activeModel = computed(() => {
      if (
        selectedFinder.value &&
        selectedBrand.value &&
        selectedModel.value &&
        fittingList.value.length
      ) {
        return fittingList.value.find(
          (item) =>
            item.finder.finder_id === selectedFinder.value.finder_id &&
            item.brand.brand_id === selectedBrand.value.brand_id &&
            item.model.model_id === selectedModel.value.model_id
        );
      } else if (pfUrlArguments) {
        return fittingList.value.find(
          (item) =>
            item.finder.slug === pfUrlArguments.finder &&
            item.brand.slug === pfUrlArguments.brand &&
            item.model.slug === pfUrlArguments.model
        );
      }
      return null;
    });

    onMounted(async () => {
      fittingList.value = await load();
    });

    return {
      loading,
      error,
      query,
      activeModel,
    };
  },
});
